<template>
  <div class="main">
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">入宿 QRCode 報到</h2>
      </header>
      <div class="panel-body">
        <p v-if="loading">資料驗證中，請稍候...</p>
        <div v-else>
          <p :class="statusClass">{{ message }}</p>
          <p v-if="reportDate">報到時間：{{ customFormatter(reportDate, "YYYY/MM/DD HH:mm:ss") }}</p>
        </div>
        <div style="margin-top: 12px;">
          <button class="btn btn-default" @click="goBack">返回</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      message: "",
      statusClass: "text-info",
      reportDate: "",
    };
  },
  mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.loading = false;
      this.statusClass = "text-danger";
      this.message = "缺少 QRCode 資料";
      return;
    }

    if (!this.sessionData || !this.sessionData.account) {
      // 尚未登入：保留 QRCode token，開啟登入視窗
      // 存 localStorage:登入流程會呼叫 clearStore()(= sessionStorage.clear()),sessionStorage 會被清掉
      localStorage.setItem("pendingCheckinToken", token);
      this.showLoginPopup();
      this.loading = false;
      this.statusClass = "text-info";
      this.message = "請先登入後，系統將自動完成報到。";
      return;
    }

    this.doCheckin(token);
  },
  methods: {
    doCheckin(token) {
      this.loading = true;
      this.$axios.post("/api/Room/checkinByQrcode", { token }).then((resp) => {
        this.loading = false;
        if (resp.data.status === "success") {
          this.statusClass = "text-success";
          this.message = resp.data.msg || "報到成功";
          this.reportDate = resp.data.data && resp.data.data.reportDate;
        } else {
          this.statusClass = "text-danger";
          this.message = resp.data.msg || "報到失敗";
        }
      });
    },
    goBack() {
      // 用整頁導回首頁,讓 App.vue 重新掛載(URL 不帶 query)以重建側邊選單
      window.location.href = "/";
    },
  },
};
</script>

<style scoped>
</style>
